import AOS from 'aos';
import CC from "cookieconsent"
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';

import Polyfills from './polyfills';

import Botany from './botany';
import Enquiries from './enquiries';
import Nav from './nav';
import Overlays from './overlays';
import SealAnim from './seal-anim';
import Timeline from './timeline';
import Cursor from './cursor';
import Slider from './slider';

// initialise Swup
const swup = new Swup({
  plugins: [
    new SwupScrollPlugin({
      doScrollingRightAway: true,
      animateScroll: false,
    },
    )],
  animationSelector: '.c-interstitial--animate',
});

// contains all functionality that should
// run on each page load (including Swup transitions)
const init = function() {
  Polyfills.init();
  Botany.init();
  Enquiries.init();
  Nav.init()
  Overlays.init();
  SealAnim.init();
  Timeline.init();
  Cursor.init();
  Slider.init();

  window.addEventListener('scroll', toggleLogoOnScroll);
};

function toggleLogoOnScroll(_) {
  if(window.scrollY >= 80) {
    // user has scrolled past 80px
    document.getElementById('header').classList.add('is-scrolled');
  } else {
    document.getElementById('header').classList.remove('is-scrolled');
  }
}

// event listener for Swup
// reruns our init() function whenever the page transitions
swup.on('contentReplaced', () => {
  // IE does not support multiple arguments for classList remove/add
  // document.body.classList.remove('trigger-anim', 'u-vp-no-scroll');
  document.body.classList.remove('trigger-anim');
  document.body.classList.remove('u-vp-no-scroll');
  AOS.refresh();
  Cursor.reset();
  init();
});

// native event listener
// runs our init() function whenever the page loads
document.addEventListener('DOMContentLoaded', () => {
  AOS.init();
  CC;
  init();
});

window.addEventListener('load', () => {
  AOS.refresh();
  window.cookieconsent.initialise({
    content: {
      dismiss: 'Accept',
      message: 'This website only uses cookies that are necessary for the site to function and they do not contain any personal data.'
    },
    palette: {
      button: {
        background: '#D3703B',
        text: '#F2F1F0'
      },
      popup: {
        background: '#F2F1F0',
        text: '#3F3831'
      },
      highlight: {
        background: '#A35B37',
        text: '#3F3831'
      }
    },
    position: 'bottom-left'
  });
});
